import ApiService from "@/common/api.service";
import { SET_ERROR } from "./mutations.type";

const state = {
    menu: {
        "merchantId": "",
        "menuMeal": [{
            "name": "",
            "price": 0,
            "description": "",
            "inventory":0,
        }],
        "minPrice": 0,
        "status": ""
    },
}

const getters = {
    menu() {
        return state.menu
    }
}

const actions = {
    async fetchMenu(context, menuSlug) {
        return new Promise(resolve => {
            ApiService.get("menu", menuSlug)
                .then(({ data }) => {
                    context.commit("setMenu", data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    },
    async menuEdit(context) {
        return new Promise(resolve => {
            ApiService.update("menu", state.menu)
                .then(({ data }) => {
                    context.commit("setMenu", data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    },
    async menuCreate(context) {
        return new Promise(resolve => {
            ApiService.post("menu", state.menu)
                .then(({ data }) => {
                    context.commit("setMenu", data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    },
    mealAdd() {
        if (state.menu.menuMeal === null) {
            state.menu.menuMeal = [];
        }
        state.menu.menuMeal.push({});
    },
    mealDel(context, index) {
        state.menu.menuMeal.splice(index, 1);
    },
}

const mutations = {
    setMenu(state, menu) {
        state.menu = menu
    },
}

export default {
    state,
    getters,
    actions,
    mutations
};
